import { ChangeDetectorRef, Component, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { NgbModal, NgbModalConfig, NgbTypeaheadSelectItemEvent } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { CustomPaggerService } from 'projects/Autofacets-Core/src/app/common-services/custom-pagger.service';
import { NgbdSortableHeader, SortEvent } from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import * as Enums from 'projects/Autofacets-Core/src/app/utils/enums';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { DealerViewModel } from '../../../business-entities/dealer-view-model';
import { MechanicTimeCodeDetailsListViewModel } from '../../../business-entities/mechanic-time-code-model';
import { SelectListItemViewModel } from '../../../business-entities/select-list-item-view-model';
import { UserRoleMenu } from '../../../business-entities/user-role-menu.model';
import { MechanicTimeCodeBusinessService } from './../../../business-services/mechanic-time-code.service';
import { AddMechanicTimeCodeComponent } from './add-mechanic-time-code/add-mechanic-time-code/add-mechanic-time-code.component';
import { EditMechanicTimeCodeComponent } from './edit-mechanic-time-code/edit-mechanic-time-code/edit-mechanic-time-code.component';
import { AdminCommonService } from '../../../services/admin-common.service';
@Component({
  selector: 'app-mechanic-time-code',
  templateUrl: './mechanic-time-code.component.html'
})
export class MechanicTimeCodeComponent implements OnInit, OnDestroy {
  paginationSub: Subscription
  currentlagSub: Subscription
  mechanicTimeCodeList: MechanicTimeCodeDetailsListViewModel[] = []
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  dealerValues: DealerViewModel[];
  userRoleRightsDetails: UserRoleMenu;
  constructor(
    private currentLanguageService: CurrentLanguage,
    private cd: ChangeDetectorRef,
    public pService: CustomPaggerService,
    private spinner: NgxSpinnerService,
   private adminCommonService :AdminCommonService,
    public mechanicTimeCodeService: MechanicTimeCodeBusinessService,
    private userService: UserDataService,
    private modalService: NgbModal,
    config: NgbModalConfig,
  ) {
    this.pService.pageSize = 10;
    this.pService.searchby = ['timeCode','dealerName','description'];
    this.pService.searchTerm = '';
    config.backdrop = 'static';
    config.keyboard = false;
  }

  onSort({ column, direction }: SortEvent) {
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    this.pService.sortColumn = column;
    this.pService.sortDirection = direction;
  }

  ngOnDestroy(): void {
    if (this.paginationSub) {
      this.paginationSub.unsubscribe();
    }
    this.currentlagSub.unsubscribe();
    this.pService.dealers$ = new BehaviorSubject<any[]>([]);
    this.pService.total$ = new BehaviorSubject<number>(0);
  }

  ngOnInit(): void {
    this.userRoleRightsDetails = (this.userService.currentUserValue.userRoleMenuDetails as any[]).find(menu => menu.moduleId === Enums.ModuleNames.MechanicTimecode);
    this.pService.dataSource = [];

    if ( this.mechanicTimeCodeService.isEdit) {
      this.mechanicTimeCodeService.isEdit = false;
    }
    this.cd.detectChanges();
    this.currentlagSub = this.currentLanguageService.currentLanguage.subscribe(x => {
      this.getMechanicTimeCodeList("", x);
    });
  }
  formatter = (result: SelectListItemViewModel) => result.text.toUpperCase();

  search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(_term => {
        return {}
      })
    )

  setDealer(event: NgbTypeaheadSelectItemEvent) {
    event.preventDefault();
    this.currentlagSub = this.currentLanguageService.currentLanguage.subscribe(x => {
      this.getMechanicTimeCodeList("", x);
    });
  }

  handleResultSelected(result) {
    this.search = result;
  }

  async getMechanicTimeCodeList(dealerId: string, language: string) {
    this.spinner.show();
    await this.mechanicTimeCodeService.getMechanicTimeCodeList(dealerId, language).then((response) => {
      if (response.mechanicTimeCodeList) {
        this.pService.dataSource = response.mechanicTimeCodeList;
        this.paginationSub = this.pService.dealers$.subscribe(result => {
          this.mechanicTimeCodeList = this.mechanicTimeCodeMapping(result);
        });
      }

    })
    this.spinner.hide();
  }
  private mechanicTimeCodeMapping(mechanicTimeCodeList: any) {
    let supperArray = [];
    if (mechanicTimeCodeList && mechanicTimeCodeList.length > 0) {

      for (let index = 0; index < mechanicTimeCodeList.length; index++) {
        const element = mechanicTimeCodeList[index];

        let single = Object();
        single.rowNumber = this.adminCommonService.currentPageNumber(index);
        single.id = element.id;
        single.dealerId = element.dealerId;
        single.dealerName = element.dealerName;
        single.isShow = element.isShowInDWO;
        single.timeCode = element.timeCode
        single.description = element.description
        supperArray.push(single);
      }
    }
    return supperArray;
  }
  onAdd() {
    const modalref = this.modalService.open(AddMechanicTimeCodeComponent, { size: 'md', windowClass: 'EditPopup' });
    modalref.result.then((response) => {
      if (response.success) {
        this.ngOnInit();
      }
    });
  }
  onEdit(id: number) {
    this.mechanicTimeCodeService.mechanicTimeCodeId = id
    const modalref = this.modalService.open(EditMechanicTimeCodeComponent, { size: 'md', windowClass: 'EditPopup' });
    modalref.result.then((response) => {
      if (response.success) {
        this.ngOnInit();
      }
    });
  }
  
}
